<section class="FirstScroll_Section">

    <div class="contact3">
        <div class="row no-gutters">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="card-shadow">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14020.429993492844!2d77.1386637819526!3d28.53648841929071!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd3522132487%3A0x5decdf23b12670c3!2sAll%20India%20Council%20For%20Technical%20Education!5e0!3m2!1sen!2sin!4v1617255976498!5m2!1sen!2sin" height="470" style="border:0;width: 100%;" allowfullscreen="" loading="lazy"></iframe>                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="contactBox ml-3">
                  <h1 class="font-weight-light mt-2">Quick Contact</h1>
                  <form class="mt-4" [formGroup]="contactForm" (ngSubmit)="onSubmit(contactForm.value)">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="form-group mt-2">
                          <mat-form-field class="w-100" [floatLabel]="'never'" >
                            <mat-label>Name</mat-label>
                           
                            <input matInput class="form-control" type="text" placeholder="name" formControlName="name" maxlength="100">
                          <mat-error *ngIf="contactForm.controls.name.errors?.required">Name is required
                          </mat-error>
                          <mat-error *ngIf="contactForm.controls.name.errors?.minlength">Required (greater
                              than 3
                              characters)</mat-error>
                            </mat-form-field>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group mt-2">
                          <mat-form-field class="w-100" [floatLabel]="'never'" >
                            <mat-label>Email</mat-label>
                            
                            <input matInput class="form-control" type="email" placeholder="email" formControlName="email" maxlength="100">
                            <mat-error *ngIf="contactForm.controls['email'].hasError('pattern')">Invalid Email
                              Address</mat-error>
                            </mat-form-field>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group mt-2">
                          <mat-form-field class="w-100" [floatLabel]="'never'" >
                            <mat-label>Contact</mat-label>
                            
                            <input matInput class="form-control" type="text" placeholder="Contact"
                                (keypress)="checkPhoneNumber($event)" formControlName="phone" maxlength="10">

                            <mat-error *ngIf="contactForm.controls['phone'].hasError('minlength')">Mobile Number
                                should be of 10 numbers</mat-error>
                            <mat-error *ngIf="contactForm.controls['phone'].hasError('pattern')">Invalid Mobile Number
                            </mat-error>
                        </mat-form-field>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group mt-2">
                          <mat-form-field class="w-100" [floatLabel]="'never'" >
                            <mat-label>Message</mat-label>
                            
                            <textarea matInput class="form-control" rows="3" placeholder="message" formControlName="message"></textarea>
                          <mat-error *ngIf="contactForm.controls.message.errors?.required">Message is required
                          </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <button type="submit" class="btn submitBtn"><span> SUBMIT</span></button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="card mt-4 border-0 mb-4">
                  <div class="row">
                    <div class="col-lg-4 col-md-4 nopad">
                      <div class="card-body d-flex align-items-center c-detail pl-0">
                        <div class="mr-3 align-self-center">
                          <img src="./assets/images/ContactUs_Icons/icon1.png">
                        </div>
                        <div class="">
                          <h6 class="contactHeading font-weight-medium">Address</h6>
                          <p class="">Nelson Mandela Marg,
                            <br> Vasant Kunj, New Delhi-110070</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 nopad">
                      <div class="card-body d-flex align-items-center c-detail">
                        <div class="mr-3 align-self-center">
                          <img src="./assets/images/ContactUs_Icons/icon2.png">
                        </div>
                        <div class="">
                          <h6 class="contactHeading font-weight-medium">Phone</h6>
                          <p class="">011-29581527<br><br></p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 nopad">
                      <div class="card-body d-flex align-items-center c-detail">
                        <div class="mr-3 align-self-center">
                          <img src="./assets/images/ContactUs_Icons/icon3.png">
                        </div>
                        <div class="">
                          <h6 class="contactHeading font-weight-medium">Email</h6>
                          <p class="">
                            parakh@aicte-india.org<br><br>
                            <!-- parakh@aicte-india.org<br><br> -->
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

</section>

<div class="clearfix"></div>